import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ITimetableDetail } from '../getTimetable';
import { IUpdateTimetableDetailsRequestBody, IUpdateTimetableDetailsResponse } from './types';

const FALLBACK_ERROR_MESSAGE = 'Something went wrong whilst updating the timetable';

// Surfaces the backend's validation message (e.g. "Name must be unique for the brand") where
// there is one, the same way postTimetableRequest does for create/duplicate.
const getErrorMessage = async (response: Response): Promise<string> => {
  try {
    const json = await response.json();
    const hasErrorMsg = !!json && typeof json === 'object' && 'message' in json && typeof json.message === 'string';
    return hasErrorMsg ? json.message : FALLBACK_ERROR_MESSAGE;
  } catch {
    return FALLBACK_ERROR_MESSAGE;
  }
};

export const updateTimetableDetails = async (
  timetableId: string,
  requestBody: IUpdateTimetableDetailsRequestBody,
): Promise<ITimetableDetail> => {
  const response = await fetch(`${API_URL}/timetables/${timetableId}`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.status !== Status.SUCCESS) {
    throw new Error(await getErrorMessage(response));
  }

  const { data }: IUpdateTimetableDetailsResponse = await response.json();
  return data;
};
